import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { LoadingContent } from 'Shared/PageElements';
import { PageWrapper } from 'Shared/PageWrapper';
import { conversationsSelectors } from 'State';
import ConversationsDetailPage from './ConversationsDetailPage';
import ConversationsListPage from './ConversationsListPage';

function ConversationsPage(): React.ReactElement {
    const { t } = useTranslation(['conversationsFeature']);
    const { path } = useRouteMatch();

    const conversationsAreLoaded: boolean = useSelector(conversationsSelectors.conversationsAreLoaded);

    return (
        <PageWrapper pageTitle={t('conversationsFeature:conversationsList.title')}>
            {conversationsAreLoaded ? (
                <>
                    <Switch>
                        <Route path={`${path}/:conversationId`}>
                            <ConversationsDetailPage />
                        </Route>
                        <Route path={`${path}`}>
                            <ConversationsListPage />
                        </Route>
                    </Switch>
                </>
            ) : (
                <LoadingContent />
            )}
        </PageWrapper>
    );
}

export default ConversationsPage;
